import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';

export const SECONDARY_SELECT = [
    SystemEntity.Party,
    SystemEntity.Person,
    SystemEntity.Organisation,
    SystemEntity.ClientProduct,
];
